export default __webpack_public_path__ + "static/m-feature-4-bebb5f245f3b9de3b00894e8d1570cc9.png";